import { DEFAULT_API_BASE_URL } from './constants';
import { getMerchantName } from './merchantName';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

const merchantName = getMerchantName();

const backendLoginUrl = `${apiBaseUrl}/organization-service/dashboard/auth0/${merchantName}/login`;
const backendLogoutUrl = `${apiBaseUrl}/organization-service/dashboard/auth0/${merchantName}/logout`;

export { backendLoginUrl, backendLogoutUrl };
